import { motion } from "framer-motion";

/**
 * Reveal - fades and slides children in when scrolled into view.
 * Uses framer-motion's whileInView so it triggers on scroll for every section.
 */
export const Reveal = ({
  children,
  delay = 0,
  y = 24,
  duration = 0.75,
  className = "",
  as: Tag = "div",
  once = true,
  amount = 0.25,
}) => {
  const MotionTag = motion[Tag] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount }}
      transition={{ duration, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </MotionTag>
  );
};

/**
 * Stagger - a container that staggers its immediate children.
 * Use with StaggerItem for each child.
 */
export const Stagger = ({ children, className = "", delay = 0, stagger = 0.08, amount = 0.2 }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, amount }}
    variants={{
      hidden: {},
      show: {
        transition: {
          staggerChildren: stagger,
          delayChildren: delay,
        },
      },
    }}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className = "", y = 20 }) => (
  <motion.div
    className={className}
    variants={{
      hidden: { opacity: 0, y },
      show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] } },
    }}
  >
    {children}
  </motion.div>
);
